var map = {
	"./aandhikhola-geojson.json": [
		950,
		31
	],
	"./amargadhi-geojson.json": [
		951,
		30
	],
	"./annapurna_kaski-geojson.json": [
		952,
		29
	],
	"./bagmati-geojson.json": [
		953,
		28
	],
	"./bannigadhijayagadh-geojson.json": [
		954,
		27
	],
	"./barhabise-geojson.json": [
		955,
		26
	],
	"./bheri-geojson.json": [
		956,
		25
	],
	"./chaurpati-geojson.json": [
		957,
		24
	],
	"./chure-geojson.json": [
		958,
		23
	],
	"./demo-geojson.json": [
		959,
		22
	],
	"./dhangadhi-geojson.json": [
		100,
		0
	],
	"./dhangadhi_plus-geojson.json": [
		960,
		21
	],
	"./durgathali-geojson.json": [
		961,
		20
	],
	"./gauriganga-geojson.json": [
		962,
		19
	],
	"./godawari-geojson.json": [
		963,
		18
	],
	"./jayaprithvi-geojson.json": [
		964,
		17
	],
	"./kailari-geojson.json": [
		965,
		16
	],
	"./kathmandu-geojson.json": [
		966,
		15
	],
	"./khaptadchanna-geojson.json": [
		967,
		14
	],
	"./kirtipur-geojson.json": [
		968,
		13
	],
	"./konjyosom-geojson.json": [
		969,
		12
	],
	"./mahalaxmi-geojson.json": [
		970,
		11
	],
	"./mahankal-geojson.json": [
		971,
		10
	],
	"./mangalsen-geojson.json": [
		972,
		9
	],
	"./masta-geojson.json": [
		973,
		8
	],
	"./melamchi-geojson.json": [
		974,
		7
	],
	"./mellekh-geojson.json": [
		975,
		6
	],
	"./nalgaad-geojson.json": [
		976,
		5
	],
	"./nawadurga-geojson.json": [
		977,
		4
	],
	"./parashuram-geojson.json": [
		978,
		3
	],
	"./sanfebagar-geojson.json": [
		979,
		2
	],
	"./yipl-geojson.json": [
		980,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 155;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/visualization/geojson lazy ^\.\/.*\-geojson\.json$
// module id = 155
// module chunks = 32